module.exports = __webpack_public_path__ + "img/poster-1.8558f99b.jpg";